import { render, staticRenderFns } from "./MultipleChoice.vue?vue&type=template&id=7c271230&scoped=true&"
import script from "./MultipleChoice.vue?vue&type=script&lang=js&"
export * from "./MultipleChoice.vue?vue&type=script&lang=js&"
import style0 from "./MultipleChoice.vue?vue&type=style&index=0&id=7c271230&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c271230",
  null
  
)

export default component.exports